import { cartPageContainerStyles } from "@insite/content-library/Widgets/Cart/CartPageContainer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

cartPageContainerStyles.cartTotalContainer = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        border: 0 solid transparent;
                        border-width: 0 1.5rem 1.5rem 0;
                    `,
                    null,
                    css`
                        grid-column-start: 2;
                        -ms-grid-column: 2;
                        grid-row-start: 3;
                        -ms-grid-row: 3;
                        margin-top: 2rem;
                    `,
                    css`
                        margin-top: 15px;
                    `,
                ],
                "min",
            )}
    `,
};
